import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NovuProvider } from '@novu/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './utils/themeConfig'; // Import ThemeProvider

import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey('[v3][RELEASE][0102]_NDg2Njc4MzY3MDgzNw==16d78ca762fb5d2ff740aed081e2af7b');

import { AuthProvider, useAuthContext } from './context/AuthContext';
import ReduxProvider from './components/redux/ReduxProvider';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Component to wrap NovuProvider and get subscriberId from AuthContext
const NovuWrapper = () => {
  const { user, loading } = useAuthContext();
  const subscriberId = user?.patientId || user?.email || 'anonymous'; // Use user ID or email

  // Only render NovuProvider if user is loaded and subscriberId is available
  if (loading || !subscriberId) {
    return <App />; 
  }

  return (
    <NovuProvider
      apiUrl={process.env.REACT_APP_NOVU_SERVER_URL}
      applicationIdentifier={process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER}
      subscriberId={subscriberId}
    >
      <App />
    </NovuProvider>
  );
};

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReduxProvider>
        <AuthProvider>
          <ThemeProvider>
            <NovuWrapper />
          </ThemeProvider>
        </AuthProvider>
      </ReduxProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);